import { Mappable } from '../../_shared/mappable.class';

import { Location } from './Location'

export class PosStation extends Mappable<PosStation>  {

    stationId: number;
    name: string;
    description: string;
    assigned: boolean;
    dateCreated: Date;
    allowGuests: boolean;

    location: Location;

    reader: Reader;
    printer: Printer;
}

export class Reader {
    posReaderId: number;
    name: string;
    code: string;
    type: string;
    serialNumber: string;
    dateCreated: Date;
}

export class Printer {
    posPrinterId: number;
    name: string;
    macAddress: string;
    dateCreated: Date;
}

export class StationApp extends Mappable<StationApp> {
    description: string;
    version: string;
    forceUpdate: boolean;
    current: boolean;
}